import { Injectable } from '@angular/core';
import { Option, StaticStringSelectDisplayService } from '../static-string-select/static-string-select.component';
import { TranslateService } from '@ngx-translate/core';
import { OpportunityStatusOptions } from './opportunity-status-options-component';

@Injectable({ providedIn: 'root' })
export class OpportunityStatusOptionsDisplayService extends StaticStringSelectDisplayService {
  options: Option[] = OpportunityStatusOptions;

  constructor(private readonly translateService: TranslateService) {
    super();
    //Need to translate the options cause they can't be translated in the template
    this.options.map((o) => {
      o.label = this.translateService.instant(o.label);
      return o;
    });
  }
}
